import type { GetUsersOptions } from '@/services/AdminService'

export type CompanyPick = { id: string; name: string }

export type UserListFilterState = {
  searchTerm: string
  roleFilter: string
  platformAdminFilter: 'any' | 'yes' | 'no'
  createdFrom: string
  createdTo: string
  companyFilter: CompanyPick | null
  noCompany: boolean
}

/** Maps User Management UI state to `GET /api/admin/users` query options. */
export function buildAdminUserListRequestOptions(
  page: number,
  limit: number,
  f: UserListFilterState
): GetUsersOptions {
  const createdFrom = f.createdFrom ? `${f.createdFrom}T00:00:00.000Z` : undefined
  const createdTo = f.createdTo ? `${f.createdTo}T23:59:59.999Z` : undefined
  return {
    limit,
    skip: (page - 1) * limit,
    search: f.searchTerm.trim() || undefined,
    role: f.roleFilter === 'all' ? undefined : f.roleFilter,
    isPlatformAdmin:
      f.platformAdminFilter === 'any' ? undefined : f.platformAdminFilter === 'yes',
    createdFrom,
    createdTo,
    companyId: f.noCompany ? undefined : f.companyFilter?.id,
    noCompany: f.noCompany ? true : undefined,
  }
}
